import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { ApiServicesService } from '../services/api-services.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LCA } from 'src/app/data/models/lca.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-beneficiary-lca',
  templateUrl: './beneficiary-lca.component.html',
  styleUrls: ['./beneficiary-lca.component.scss']
})

export class BeneficiaryLcaComponent implements OnInit, AfterContentInit, OnDestroy {

  beneficiaryId: number;
  lcaList: LCA[] = [];  
  dataSource: MatTableDataSource<any>;  
  totalRecordCount: number = 0;
  displayedColumns: string[] = [];
  envPath: any;

  columns = [
    { columnDef: 'caseNumber', header: 'Case No.', columnType: 'text', customClass: '' },
    { columnDef: 'jobTitle', header: 'SOC Job Title', columnType: 'text', customClass: '' },
    { columnDef: 'socCode', header: 'SOC Code', columnType: 'text', customClass: '' },
    { columnDef: 'employmentStartDate', header: 'Start', columnType: 'text', customClass: '' },
    { columnDef: 'employmentEndDate', header: 'End', columnType: 'text', customClass: '' },
    { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
    { columnDef: 'visaType', header: 'Visa Type', columnType: 'text', customClass: '' },
    { columnDef: 'comment', header: 'Notes', columnType: 'text', customClass: 'mat-cell-wrap-text' },
    { columnDef: 'status', header: 'Status', columnType: 'text', customClass: '' },
    { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }   
  ];

  constructor(
    private toastService: ToastrService,
    private authenticationService: AuthenticationService,
    private apiService: ApiServicesService
  ) { }

  ngOnInit(): void {
    this.envPath = environment.docs;
    this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];    
    this.listBeneficiaryLCA();
  }

  ngAfterContentInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);   
  }

  listBeneficiaryLCA(){
    this.apiService.getBeneficiaryLCA(this.beneficiaryId).subscribe((data: any) => {  
      this.lcaList = data['lcaApplicationResponseDto'];      
      this.totalRecordCount = this.lcaList.length;  
      this.dataSource = new MatTableDataSource(this.lcaList);       
    });
  }

  ngOnDestroy() {
    
  }

}
